/**
 * PHM(인사기본·인적마스터) 도메인 라우트 - 인사기본 > 구성원 관리·인사정보 메뉴.
 * route name = OBJECT_ID, 상단 PLAN_MENU 인사기본 리프 route 와 1:1. 폴더=도메인=pages/phm.
 */
const routes = [
  {
    // 모든 구성원 - 구성원 전체 조회 + 계정 잠금/해제 (인사기본 > 구성원 관리)
    path: 'phm/member-all',
    name: 'PHM0010',
    component: () => import('@/pages/phm/PHM0010.vue'),
    meta: {
      requiresAuth: true,
      title: '모든 구성원',
      menuId: 'PHM0010',
      objInfo: 'PHM0010 · 인사기본/구성원 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 개인인사정보(카드뷰) - 기본 bar + 요약카드 15종 + 네비게이션 바 + 상세 그리드 전환 (인사기본 > 인사정보)
    path: 'phm/info-personal',
    name: 'PHM0110',
    component: () => import('@/pages/phm/PHM0110.vue'),
    meta: {
      requiresAuth: true,
      title: '개인인사정보',
      menuId: 'PHM0110',
      objInfo: 'PHM0110 · 인사기본/인사정보 (미래모델·퍼블리싱)',
    },
  },
  {
    // 전체인사정보(일괄관리) - SG 검색(기준일·조직·구성원) + 항목 카드 -> 다인 그리드(좌측 고정+항목 컬럼) (인사기본 > 인사정보)
    path: 'phm/info-all',
    name: 'PHM0120',
    component: () => import('@/pages/phm/PHM0120.vue'),
    meta: {
      requiresAuth: true,
      title: '전체인사정보',
      menuId: 'PHM0120',
      objInfo: 'PHM0120 · 인사기본/인사정보 (미래모델·퍼블리싱)',
    },
  },
  {
    // 변경내역조회 - SG 조회(기준기간·조직·구성원·인사 정보·변경 종류) + 조회전용 그리드(변경 전/후, 다운로드만) (인사기본 > 인사정보)
    path: 'phm/info-history',
    name: 'PHM0130',
    component: () => import('@/pages/phm/PHM0130.vue'),
    meta: {
      requiresAuth: true,
      title: '변경내역조회',
      menuId: 'PHM0130',
      objInfo: 'PHM0130 · 인사기본/인사정보 (미래모델·퍼블리싱)',
    },
  },
  {
    // 구성원 초대 - 조회(초대 상태·완료자 제외) + 초대자 목록 그리드(7컬럼) + 초대 메일 발송 A/B·초대 취소·재발송 가드 (인사기본 > 구성원 관리)
    path: 'phm/member-invite',
    name: 'PHM0020',
    component: () => import('@/pages/phm/PHM0020.vue'),
    meta: {
      requiresAuth: true,
      title: '구성원 초대',
      menuId: 'PHM0020',
      objInfo: 'PHM0020 · 인사기본/구성원 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 데이터 코드 관리 - 자격증 · 어학 · 포상 · 징계 코드 4탭 (환경설정 > 인사 관리)
    path: 'env/data-code',
    name: 'PHM0150',
    component: () => import('@/pages/phm/PHM0150.vue'),
    meta: {
      requiresAuth: true,
      title: '데이터 코드 관리',
      menuId: 'PHM0150',
      objInfo: 'PHM0150 · 환경설정/인사 관리/데이터 코드 관리',
    },
  },
];

export default routes;
